import { Box, BoxProps, Form, PrimaryButton } from '@wrisk/ui-components'
import React, { FunctionComponent, useMemo } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import { FormErrorsPortal, FormFooter, FormSections } from './components'
import { FormBuilderOptions, FormBuilderProps } from './types'

const INPUT_SECTION_CLASS = 'input-section'
const ERROR_MESSAGE_CLASS = 'error-message'

const defaultOptions: FormBuilderOptions = {
  shouldUnregister: false,
  disableReadOnly: false,
}

export const FormErrors: FunctionComponent<FormBuilderProps & BoxProps> = ({
  id,
  footerText,
  data,
  inputs,
  onSubmit,
  loading,
  options = {},
  tKey,
  t,
  ...props
}) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const finalOptions = useMemo(() => ({ ...defaultOptions, ...options }), [])

  const form = useForm({
    defaultValues: data,
    shouldUnregister: finalOptions.shouldUnregister,
  })

  return (
    <Box width={1} {...props}>
      <FormProvider {...form}>
        <Form formId={id} onSubmit={form.handleSubmit(onSubmit)}>
          <FormSections
            inputs={inputs}
            options={finalOptions}
            sectionClassName={INPUT_SECTION_CLASS}
            errorClassName={ERROR_MESSAGE_CLASS}
            tKey={tKey}
            t={t}
          />
          <FormFooter tKey={tKey} tName={footerText} t={t} />
          <PrimaryButton
            type='submit'
            layout='fixed'
            loading={loading}
            data-testid='button-continue'
          >
            {t([tKey('actions.continue'), 'defaults.actions.continue'])}
          </PrimaryButton>
        </Form>
        <FormErrorsPortal
          tKey={tKey}
          t={t}
          scrollToClass={INPUT_SECTION_CLASS}
          errorClass={ERROR_MESSAGE_CLASS}
        />
      </FormProvider>
    </Box>
  )
}
